var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tkTaskView.countChild > 0)?_c('div',{},[_c('el-tooltip',{attrs:{"content":'Có số công việc con: ' + _vm.tkTaskView.countChild}},[_c('span',{staticClass:"color__green"},[_c('i',{staticClass:"fas fa-sitemap"}),_vm._v("\n      "+_vm._s("(" + _vm.tkTaskView.countChild + ")")+" \n    ")])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fceab7f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/job/components/task-child-tag.vue
// module id = null
// module chunks = 